import { EveRoutes } from '@ver-uds/e-verify';
import { VisAuthService } from '@vis-auth/react';
import { History } from 'history';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeEmptyStrings = (data: { [key: string]: any }): void => {
  const newData = data;
  Object.entries(data).forEach(([k, v]) => {
    if (v === '') {
      delete newData[k];
    } else if (typeof v === 'object') {
      removeEmptyStrings(v);
    }
  });
};

export const scrollToTop = (): void => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
  document.body.scrollTop = 0;
};

// Redirects to url and scrolls to top
export const redirectToUrl = (history: History, url = '/'): void => {
  history.push(url);
  scrollToTop();
};

export const getAuthServiceMFA = (
  authUrl: string,
  LoginDotGovClientId: string,
  LoginDotGovUrl: string,
): VisAuthService => {
  const authService = new VisAuthService({
    issuer: authUrl,
    clientId: LoginDotGovClientId,
    redirectUri: window.location.origin + EveRoutes.LOGIN,
    tokenStorage: 'cookie',
    errorPath: '/error',
    loginDotGovUrl: LoginDotGovUrl,
    logoutUri: window.location.origin + EveRoutes.LOGOUT,
  });

  return authService;
};
